import { useState, useCallback } from 'react';
import { polygonStatsService, } from '../services/polygonStatsService';
export const usePolygonStats = (projectId) => {
    const [statistics, setStatistics] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const calculate = useCallback(async (polygonGeojson, areaM2) => {
        if (!projectId) {
            setError('No project selected');
            return;
        }
        try {
            setLoading(true);
            setError(null);
            const result = await polygonStatsService.calculatePolygonStatistics({
                projectId,
                polygonGeojson,
                areaM2,
            });
            setStatistics(result);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : 'Failed to calculate statistics';
            console.error('[usePolygonStats] Error:', message);
            setError(message);
            setStatistics(null);
        }
        finally {
            setLoading(false);
        }
    }, [projectId]);
    const clear = useCallback(() => {
        setStatistics(null);
        setError(null);
    }, []);
    return {
        statistics,
        loading,
        error,
        calculate,
        clear,
    };
};
